import React from 'react';
import Link from 'next/link';
import Spacing from '../spacing';
import Carousel from './carousel';
import { PropTypes } from 'prop-types';
import PropertyStatusPill from '../property-status-pill';
import PropertyCloseMatch from '../property-close-match';
import ProgressiveImage from '@oxygen/ab/ProgressiveImage';
import { toCurrency, isNewProperty } from '@leadhome/utils';
import { constructPropertyUrl, constructPropertyTitle } from 'utils/property';
import {
  Row,
  Price,
  CardContainer,
  LocationPinIcon,
  BathsIcon,
  BedsIcon,
  ParkingIcon,
  Attribute,
  BoldText,
  SpacedRow,
  Label,
  CardFooter,
  VDivider
} from './styles';

const PropertyCard = ({
  id,
  price,
  beds,
  baths,
  parking,
  suburb,
  town,
  images,
  videoUrl,
  listingDate,
  propertyType,
  isUnderOffer,
  isPriceReduced,
  isStrictMatch,
  noCarousel
}) => {
  const isNew = isNewProperty(listingDate);
  const formattedPrice = price && price > 0 ? `R${toCurrency(price)}` : null;
  const href = constructPropertyUrl({
    id,
    beds,
    propertyType,
    suburb,
    town,
    isStrictMatch
  });

  const title = constructPropertyTitle({
    id,
    beds,
    propertyType,
    suburb,
    town
  });

  return (
    <Link href={href} passHref>
      <CardContainer>
        <div>
          {noCarousel ? (
            <ProgressiveImage
              height={513}
              width={770}
              layout='responsive'
              src={images[0]?.medium}
              alt={title}
            />
          ) : (
            <Carousel id={id} href={href} images={images} alt={title} />
          )}
          <CardFooter>
            <Price>{formattedPrice}</Price>
            <Row>
              <Label>{propertyType}</Label>
              <VDivider />
              <LocationPinIcon />
              <Label>{suburb}</Label>
            </Row>
            <Spacing height={3} />
            <SpacedRow>
              <Row>
                <Attribute>
                  <BedsIcon />
                  <BoldText>{beds}</BoldText>
                </Attribute>
                <Attribute>
                  <ParkingIcon />
                  <BoldText>{parking}</BoldText>
                </Attribute>
                <Attribute>
                  <BathsIcon />
                  <BoldText>{baths}</BoldText>
                </Attribute>
              </Row>
              <Row>
                {isNew && <PropertyStatusPill status='new' />}
                {videoUrl && <PropertyStatusPill status='videoTour' />}
                {isPriceReduced && <PropertyStatusPill status='priceReduced' />}
                {isUnderOffer && <PropertyStatusPill status='underOffer' />}
              </Row>
            </SpacedRow>
          </CardFooter>
        </div>
        {!isStrictMatch && <PropertyCloseMatch />}
      </CardContainer>
    </Link>
  );
};

PropertyCard.propTypes = {
  price: PropTypes.number,
  title: PropTypes.string,
  suburb: PropTypes.string,
  beds: PropTypes.number,
  baths: PropTypes.number,
  parking: PropTypes.number,
  isUnderOffer: PropTypes.bool,
  isPriceReduced: PropTypes.bool,
  videoUrl: PropTypes.string,
  noCarousel: PropTypes.bool
};

export default React.memo(PropertyCard);
